<template>
  <div class="home">
    <div class="bg-box">
      <div class="btn" @click="download()">
        <img src="../assets/btn.gif" alt="">
      </div>
      <img class="download" src="../assets/download.gif" alt="">
      <div class="comment" id="comment">
        <img id="comment-img" src="../assets/comment.png" alt="" />
        <div id="copy"></div>
      </div>
      <div class="form" v-if="showForm">
        <div class="dialog">
          <img
            @click="showForm = false"
            class="close"
            src="../assets/close.png"
            alt=""
          />
          <form action="" name="myForm">
            <input
              class="tel"
              v-model="subData.tel"
              type="number"
              name="tel"
              placeholder="Please enter phone number"
            />
            <input type="hidden" id="gclid_field" name="gclid_field" value="" />
            <div class="code">
              <input
                v-model="subData.code"
                type="number"
                name="code"
                placeholder="Please enter the verification code"
              />
              <span @click="!sending ? sendCode() : ''">{{ code_msg }}</span>
            </div>
          </form>
          <div class="sub-btn" @click="subCode()">Submit</div>
          <div class="privacy-sub">
            I have read and agree to
            <span @click="showPrivacy()">《Privacy Policy》</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import * as api from "@/api/api";
import Toast from "vant/lib/toast";
import "vant/lib/toast/style";
export default {
  name: "English",
  components: { Toast },
  data() {
    return {
      showForm: false,
      code_msg: "Send",
      totalTime: 60,
      sending: false,
      subData: {},
      opts: {
        loadingType: "spinner",
        duration: 0,
        forbidClick: true,
        overlay: true,
      },
      amountList: [
        { amount: "₹ 50,000", ischeck: false },
        { amount: "₹ 100,000", ischeck: false },
        { amount: "₹ 200,000", ischeck: false },
      ],
      dayList: [
        { day: "6 month", ischeck: false },
        { day: "9 month", ischeck: false },
        { day: "12 month", ischeck: false },
      ],
    };
  },
  created() {
    // Toast('res.message');
    // const toast = Toast.loading(this.opts);
    localStorage.setItem("download","https://play.google.com/store/apps/details?id=com.kantong.saku&referrer=af_tranid%3DrPITd97Bp-u8Y5P7fYMSMA%26pid%3Dgoluleasihzh_int")
  },
  mounted() {
    fbq("track", "ViewContent", {});
    ttq.track("ViewContent");
    if (!localStorage.getItem("device_id")) {
      var code_fill_str = ["000000", "00000", "0000", "000", "00", "0", ""];
      var code = "" + parseInt(Math.random() * 1000000);
      localStorage.setItem(
        "device_id",
        Date.now() + "" + code_fill_str[code.length] + code
      );
    }
    api.report({
      h5_version: "TH_v2",
      gcl_id: JSON.parse(localStorage.getItem("gclid"))
        ? JSON.parse(localStorage.getItem("gclid")).value
        : localStorage.getItem("device_id"),
      page_id: "home",
      device_id: localStorage.getItem("device_id"),
    });
    var bigBox = document.querySelector("#comment");
    var primary = document.querySelector("#comment-img");
    var copy = document.querySelector("#copy");
    this.scroll(bigBox, primary, copy, 20);
  },
  methods: {
    scroll(bigBox, primary, copy, time) {
      // if (bigBox.clientHeight >= primary.scrollHeight) {
      //   // 不需要滚动
      //   return;
      // }
      var num = 0;
      // 初始化自动滚动
      var timer = setInterval(function() {
        if ((bigBox.clientHeight + bigBox.scrollTop +3) >= primary.scrollHeight) {
          // 滚动到内容结束时，又重头开始
          bigBox.scrollTop = 0;
          num = 0;
        } else {
          num++;
          bigBox.scrollTop = num;
        }
      }, time);
    },
    downloadNow() {
      this.showForm = true;
    },
    checkAmount(index) {
      this.amountList.forEach((item) => {
        item.ischeck = false;
      });
      this.amountList[index].ischeck = true;
    },
    checkDay(index) {
      this.dayList.forEach((item) => {
        item.ischeck = false;
      });
      this.dayList[index].ischeck = true;
    },
    download() {
      api.report({
        h5_version: "TH_v2",
        gcl_id: JSON.parse(localStorage.getItem("gclid"))
          ? JSON.parse(localStorage.getItem("gclid")).value
          : localStorage.getItem("device_id"),
        page_id: "download_apk",
        device_id: localStorage.getItem("device_id"),
        fbc: this.getCookie("_fbc"),
        fbp: this.getCookie("_fbp")
      });
      fbq("track", "SubmitApplication", {});
      ttq.track("Download");
      gtag_report_conversion(window.localStorage.getItem("download"));
    },
    getCookie(cookieName) {
      const strCookie = document.cookie;
      const cookieList = strCookie.split(";");
      for (let i = 0; i < cookieList.length; i++) {
        const arr = cookieList[i].split("=");
        if (cookieName === arr[0].trim()) {
          return arr[1];
        }
      }
      return "";
    },
    showPrivacy() {
      window.open("https://www.lightningrupee.com/privacy");
    },
    sendCode() {
      if (!this.subData.tel) {
        Toast("Mobile number cannot be empty");
        return;
      }
      const toast = Toast.loading(this.opts);
      console.log(this.subData);
      this.code_msg = this.totalTime + "s";
      // window.clearInterval(clock);
      this.sending = true;
      let clock = window.setInterval(() => {
        this.totalTime--;
        this.code_msg = this.totalTime + "s";
        if (this.totalTime < 0) {
          //当倒计时小于0时清除定时器
          window.clearInterval(clock);
          this.sending = false;
          this.code_msg = "Send";
          // this.tel = "";
          this.totalTime = 60;
        }
      }, 1000);
      api
        .sendCode({
          mobile: this.subData.tel,
          gcl_id: JSON.parse(localStorage.getItem("gclid"))
            ? JSON.parse(localStorage.getItem("gclid")).value
            : localStorage.getItem("device_id"),
          url: window.localStorage.getItem("download"),
        })
        .then((res) => {
          toast.clear();
          Toast(res.message);
        })
        .catch((err) => {
          toast.clear();
          Toast(err.message);
        });
    },
    subCode() {
      if (!this.subData.tel) {
        Toast("Mobile number cannot be empty");
        return;
      }
      if (!this.subData.code) {
        Toast("The verification code cannot be empty");
        return;
      }
      const toast = Toast.loading(this.opts);
      api
        .subCode({
          mobile: this.subData.tel,
          gcl_id: JSON.parse(localStorage.getItem("gclid"))
            ? JSON.parse(localStorage.getItem("gclid")).value
            : localStorage.getItem("device_id"),
          code: this.subData.code,
        })
        .then((res) => {
          this.showForm = false;
          toast.clear();
          Toast(res.message);
          api.report({
            h5_version: "IN_v1",
            gcl_id: JSON.parse(localStorage.getItem("gclid"))
              ? JSON.parse(localStorage.getItem("gclid")).value
              : localStorage.getItem("device_id"),
            page_id: "sms_success",
            device_id: localStorage.getItem("device_id"),
            mobile: this.subData.tel,
          });
          // var that = this
          window.setTimeout(function() {
            fbq("track", "CompleteRegistration", {});
            window.location.href =
              "https://butterflyol.com/download" + window.location.search;
            // that.$router.push({path:"download"})
          }, 500);
        })
        .catch((err) => {
          toast.clear();
          Toast(err.message);
        });
    },
  },
};
</script>
<style lang="less">
@import url("@/style/m_index.less") only screen and (max-width: 750px);
@import url("@/style/pc_index.less") only screen and (min-width: 750px);
</style>
